import { useEffect, useState } from 'react';
import { useCampaignGroupsQuery } from 'src/api/campaignGroups';
import { useCampaignMappingsQuery } from 'src/api/campaignMappings';
import { CampaignGroupFilter } from 'src/types';
import { ModelVersion } from './useModelVersions';

export const useCampaignGroups = (currentModelVersion: ModelVersion | null) => {
  const [campaignGroups, setCampaignGroups] = useState<CampaignGroupFilter[]>(
    [],
  );

  const customerName = currentModelVersion?.customerName ?? 'missing_customer';
  const { data: apiGroups = [] } = useCampaignGroupsQuery(customerName);
  const { data: mappings = [] } = useCampaignMappingsQuery(customerName);

  useEffect(() => {
    if (!currentModelVersion) {
      setCampaignGroups([]);
      return;
    }

    // Campaign groups reference campaigns by mapping campaign_id.
    // Model campaigns use different names. Campaign mappings bridge the two:
    // mapping.campaign_name = name shown in groups
    // mapping.original_campaign_name = name used by model campaigns
    const idToNames = new Map<string, string[]>();
    mappings.forEach((m) => {
      const names = [m.campaign_name, m.original_campaign_name];
      idToNames.set(String(m.campaign_id), names);
    });

    const groups: CampaignGroupFilter[] = apiGroups.map((g) => ({
      id: g.id,
      groupName: g.groupName,
      campaignNames: g.campaignList.flatMap(
        (c) => idToNames.get(String(c.id)) ?? [c.name],
      ),
      selected: true,
    }));

    setCampaignGroups(groups);
  }, [apiGroups, mappings, currentModelVersion]);

  return { campaignGroups, setCampaignGroups };
};
